module.exports = __webpack_public_path__ + "img/gl2.fa92e654.jpg";